import { createContext, useEffect, useState } from 'react'
import { getCurrentZonnedTime } from 'utils/common'

const initialValue = {
  // Used for pagination component
  startSlotDate: null,
  setStartSlotDate: null,
  slotListLimit: 5,
  setSlotListLimit: null,
}

export const slotDate = (
  timeZone: string,
  initialSlotListLimit?: number
): SlotDateType => {
  const [startSlotDate, setStartSlotDate] = useState<Date | null>(
    initialValue.startSlotDate
  )
  const [slotListLimit, setSlotListLimit] = useState<number>(
    initialSlotListLimit || initialValue.slotListLimit
  )

  useEffect(() => {
    setStartSlotDate(getCurrentZonnedTime(timeZone))
  }, [timeZone])

  return {
    startSlotDate,
    slotListLimit,
    setStartSlotDate,
    setSlotListLimit,
  }
}

const SlotDateContext = createContext(initialValue)
export default SlotDateContext
